import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=ab0a76ec&scoped=true"
import script from "./OrderReview.vue?vue&type=script&lang=js"
export * from "./OrderReview.vue?vue&type=script&lang=js"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=ab0a76ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0a76ec",
  null
  
)

export default component.exports